module.exports = __webpack_public_path__ + "img/jian-zhu.964f8b08.png";